module.exports = {"130522100":"临城镇","130522101":"东镇镇","130522102":"西竖镇","130522103":"郝庄镇","130522200":"黑城乡","130522201":"鸭鸽营乡","130522203":"石城乡","130522205":"赵庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130522.json
// module id = 135
// module chunks = 0